import { PLAN_CELL_FREE, PLAN_CELL_PAID } from "@/config/publicPlans";

type PlanCompareCellProps = {
  value: string;
};

export function PlanCompareCell({ value }: PlanCompareCellProps) {
  if (value === PLAN_CELL_FREE) {
    return <span className="pub-free-pill">{value}</span>;
  }
  if (value === PLAN_CELL_PAID) {
    return <span className="pub-compare-paid">{value}</span>;
  }
  return <span>{value}</span>;
}

export function isPaidCompareRow(pricing: string) {
  return pricing === PLAN_CELL_PAID;
}
